// Store status pill. Status strings come from the Rails Store status enum
// (pending/active/paused/suspended/closed).
const LABELS: Record<string, string> = {
  pending: 'Pending', active: 'Active', paused: 'Paused',
  suspended: 'Suspended', closed: 'Closed',
}

export function StoreStatusBadge({ status }: { status: string }) {
  const key = (status || '').toLowerCase()
  return <span className={`status-pill status-pill--${key || 'pending'}`}>{LABELS[key] ?? status}</span>
}
